<template>
  <div class="flex flex-row mb-1 bg-grey-light border hover:border-blue rounded p-1">
    <div class="flex items-stretch">
      <b-icon
        :icon="status.is_completion ? 'check-circle' : 'square-full'"
        pack="fas"
        :style="{ color: status.color }"
        style="height: 1.5rem !important; width: 1.5rem !important;"
        size="is-medium">
      </b-icon>
      <!-- <span v-else class="rounded inline-block" style="width: 25px; height: 25px;"
        :style="{ backgroundColor: status.color }"></span> -->
    </div>
    <div class="flex-grow text-md mr-1 ml-1">
      <p>{{ status.name }}</p>
      <p class="text-xs text-gray-500">{{ $t('visible_to') }}: {{ _getPermissions(status) }}</p>
    </div>
    <div class="flex items-center flex-shrink-0 gap-1">
      <span @click="_OnClickEdit(status)">
        <b-icon
          icon="pencil-alt"
          pack="fas"
          type="is-info"
          size="is-small">
        </b-icon>
      </span>
      <span @click="_OnClickDelete(status)">
        <b-icon
          icon="trash-alt"
          pack="fas"
          type="is-danger"
          size="is-small">
        </b-icon>
      </span>
    </div>
  </div>
</template>

<script>
import { buildRolesTextMap } from '../../data/status-visibility-roles.js';

export default {
  name: 'Status',
  props: {
    status: { type: Object, required: true },
    visibility: { type: String, required: true },
  },
  data() {
    return {

    };
  },
  created() {
    // console.log('[Status] Status individual recibido:', {
    //   id: this.status?.id,
    //   name: this.status?.name,
    //   permissions: this.status?.permissions,
    //   hasPermissions: !!this.status?.permissions,
    //   visibility: this.visibility,
    // });
  },
  computed: {
    // Mapa value→label de roles desde la fuente única (compartida con status-form).
    rolesTextMap() {
      return buildRolesTextMap(this.$t.bind(this));
    },
  },
  methods: {
    /**
     * Normaliza los valores de visibilidad antiguos a los nuevos formatos
     */
    _normalizeVisibility(value) {
      const mapping = {
        'public': 'visible_default',
        'by_roles': 'visible_roles',
        'by_users': 'visible_users',
        'visible_default': 'visible_default',
        'visible_roles': 'visible_roles',
        'visible_users': 'visible_users',
      };
      return mapping[value] || 'visible_default';
    },

    _OnClickEdit(status) {
      this.$emit('epc-edit-status', { status })
    },

    _OnClickDelete(status) {
      this.$emit('epc-delete-status', { status })
    },

    _getPermissions(status) {
      const normalizedVisibility = this._normalizeVisibility(this.visibility);

      // Verificar si permissions existe y es un array
      if (!status.permissions || !Array.isArray(status.permissions) || status.permissions.length === 0) {
        return normalizedVisibility !== 'visible_default' ? this.$t('not_assigned') : this.$t('all');
      }

      const permissions = status.permissions
        .map(({ email, name }) => {
          if (normalizedVisibility === 'visible_roles') {
            return this.rolesTextMap[name];
          } else {
            return email;
          }
        })
        .filter(Boolean)
        .join(', ');

      return permissions || (normalizedVisibility !== 'visible_default' ? this.$t('not_assigned') : this.$t('all'));
    },
  },
}

</script>
